import type { ReducersMapObject } from 'redux';

import { signupSlice } from '../routes/signup/components/signup-model/signup.slice';

// Add new slice reducers here, for use with combineReducers api
export const rootReducers: ReducersMapObject = {
    [signupSlice.name]: signupSlice.reducer
};
